// Status de uma solicitação de auditoria
// VALUE => valor que vem da api
// LABEL => label que será exibido no select
// DESCRIPTION => descrição que será exibida no tooltip
// INT VALUE => valor mapeado no enum da api
// DISPLAY VALUE => valor exibido no frontend

export const statusSolicitacaoAuditoriaOptions = [
    {
        intValue: 1,
        displayValue: 1,
        value: 'PENDENTE_ENVIO',
        label: 'Pendente Envio',
        description: 'Aguardando a solicitação ser enviada para a unidade/gerência.'
    },
    {
        intValue: 2,     // ESSE STATUS NÃO SERÁ EXIBIDO NOS STEPS DA SOLICITAÇÃO
        value: 'AGENDADO_ENVIO',
        label: 'Agendamento Realizado',
        description: 'Aguardando a data do agendamento para enviar a solicitação.'
    },
    {
        intValue: 3,
        displayValue: 2,
        value: 'PENDENTE_UNIDADE_GERENCIA',
        label: 'Pendente Unidade/Gerência',
        description: 'Aguardando a unidade/gerência responder a solicitação.'
    },
    {
        intValue: 4,
        displayValue: 3,
        value: 'PENDENTE_ANALISE',
        label: 'Pendente Análise e Relatório',
        description: 'Aguardando os auditores analisarem a resposta da unidade/gerência e enviar um relatório.'
    },
    {
        intValue: 5,
        displayValue: 4,
        value: 'PENDENTE_RELATORIO',
        label: 'Pendente Plano de Ação',
        description: 'Aguardando a unidade/gerência anexar um plano de ação baseado no relatório do auditor.'
    },
    {
        intValue: 6,
        displayValue: 5,
        value: 'PENDENTE_ANALISE_PLANO_ACAO',
        label: 'Pendente Análise Plano de Ação',
        description: 'Aguardando os auditores analisarem o plano de ação anexado pela unidade/gerência.'
    },
    {
        intValue: 7,
        displayValue: 6,
        value: 'FLUXO_CONCLUIDO',
        label: 'Fluxo Concluído',
        description: 'Solicitação Encerrada.'
    },
];

// Status de uma solicitação diferente de auditoria
export const statusSolicitacaoDiferenteAuditoriaOptions = [
    {
        intValue: 1,
        displayValue: 1,
        value: 'PENDENTE_ENVIO',
        label: 'Pendente Envio',
        description: 'Aguardando a solicitação ser enviada para a unidade/gerência.'
    },
    {
        intValue: 2,     // ESSE STATUS NÃO SERÁ EXIBIDO NOS STEPS DA SOLICITAÇÃO
        value: 'AGENDADO_ENVIO',
        label: 'Agendamento Realizado',
        description: 'Aguardando a data do agendamento para enviar a solicitação.'
    },
    {
        intValue: 3,
        displayValue: 2,
        value: 'PENDENTE_UNIDADE_GERENCIA',
        label: 'Pendente Unidade/Gerência',
        description: 'Aguardando a unidade/gerência responder a solicitação.'
    },
    {
        intValue: 4,
        displayValue: 3,
        value: 'PENDENTE_ANALISE',
        label: 'Pendente Análise',
        description: 'Aguardando os auditores analisarem a resposta da unidade/gerência.'
    },
    {
        intValue: 7,
        displayValue: 4,
        value: 'FLUXO_CONCLUIDO',
        label: 'Fluxo Concluído',
        description: 'Solicitação Encerrada.'
    },
];
